import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  children: React.ReactNode;
  fullWidth?: boolean;
  onClick?: () => void;
}
export function Button({
  variant = 'primary',
  children,
  fullWidth = false,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 rounded-full font-semibold uppercase tracking-wider text-sm transition-all duration-300 shadow-sm hover:shadow-md';
  const variants = {
    primary: 'bg-deco-terra text-white hover:bg-deco-terra/90',
    secondary: 'bg-deco-sage text-white hover:bg-deco-sage/90'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} onClick={onClick} {...props} data-id="element-248">
      {children}
    </motion.button>;
}